var map = {
	"./icon_3d_grey.png": 353,
	"./icon_3d_red.png": 354,
	"./icon_add_point_black.png": 355,
	"./icon_add_point_red.png": 356,
	"./icon_artwork_red.png": 357,
	"./icon_artwork_white.png": 358,
	"./icon_bag_grey.png": 359,
	"./icon_bag_red.png": 360,
	"./icon_basic_shapes_red.png": 361,
	"./icon_basic_shapes_white.png": 362,
	"./icon_box_grey.png": 363,
	"./icon_box_red.png": 364,
	"./icon_cards_grey.png": 365,
	"./icon_cards_red.png": 366,
	"./icon_component_red.png": 367,
	"./icon_component_white.png": 368,
	"./icon_convert_point_black.png": 369,
	"./icon_convert_point_red.png": 370,
	"./icon_dice_grey.png": 371,
	"./icon_dice_red.png": 372,
	"./icon_download.png": 373,
	"./icon_download_black.png": 374,
	"./icon_gameboard_grey.png": 375,
	"./icon_gameboard_red.png": 376,
	"./icon_misc_grey.png": 377,
	"./icon_misc_red.png": 378,
	"./icon_move_black.png": 379,
	"./icon_move_red.png": 380,
	"./icon_paper_grey.png": 381,
	"./icon_paper_red.png": 382,
	"./icon_pawn_grey.png": 383,
	"./icon_pawn_red.png": 384,
	"./icon_pen_tool_black.png": 385,
	"./icon_pen_tool_red.png": 386,
	"./icon_pen_tool_white.png": 387,
	"./icon_point_add_red.png": 388,
	"./icon_point_add_white.png": 389,
	"./icon_point_move_red.png": 390,
	"./icon_point_move_white.png": 391,
	"./icon_point_remove_red.png": 392,
	"./icon_point_remove_white.png": 393,
	"./icon_punchboard_grey.png": 394,
	"./icon_punchboard_red.png": 395,
	"./icon_remove_point_black.png": 396,
	"./icon_remove_point_red.png": 397,
	"./icon_shipping_grey.png": 398,
	"./icon_status_red.png": 399,
	"./icon_status_white.png": 400,
	"./icon_sticker_grey.png": 401,
	"./icon_sticker_red.png": 402,
	"./icon_tray_grey.png": 403,
	"./icon_tray_red.png": 404
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;



//////////////////
// WEBPACK FOOTER
// ./app/assets/images/icons nonrecursive \.png$
// module id = 136
// module chunks = 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22